import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleModalDiagramSoftDelete, diagramSoftDelete } from '../../../redux/main/main.actions';
import { selectIsModalDiagramSoftDeleteEnabled, selectModalDiagramSoftDeleteData } from '../../../redux/main/main.selectors';

import Modal from '../Modal/Modal';
import './ModalDiagramDeleteSoft.scss';

export const ModalDiagramDeleteSoft = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramSoftDeleteEnabled);
    const modalData = useSelector(selectModalDiagramSoftDeleteData);

    const [page, setPage] = useState('');

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        setPage(modalData?.page);

        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }

        return () => { };
    }, [modalData]);

    const handleSave = () => {
        dispatch(diagramSoftDelete(modalData?.diagram?.id));
        dispatch(toggleModalDiagramSoftDelete(null));
        setTimeout(() => {
            setPage('');
        }, 300);
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramSoftDelete(null));
        setTimeout(() => {
            setPage('');
        }, 300);
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-delete-soft ${page}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`Delete diagram`}</div>
            <div className="modal-content-body">
                <div className='description-text'>{`This will delete `}<span className='text-title-bold'>{value}</span>.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>Cancel</button>
                    <button onClick={() => handleSave()}>Delete</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramDeleteSoft;
